import { application } from "./application"

import DropzoneController from "./dropzone_controller";

application.register("dropzone", DropzoneController);
